// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NYKK","col":"styles_col__axkTn"};